module.exports = __webpack_public_path__ + "img/full_logo_wg.43a9e7d5.svg";